import { Heading } from '@sparemin/blockhead';
import TableCells from 'components/TableCells';
import { Column, CellProps } from 'react-table';
import { SocialSharePodcastEpisode } from './types';

const columns: ReadonlyArray<Column<SocialSharePodcastEpisode>> = [
  {
    Header: 'Episode',
    id: 'episode',
    Cell: ({ row }: CellProps<SocialSharePodcastEpisode>) => (
      <TableCells.PodcastEpisodeCell
        thumbnailUrl={row.original.thumbnailUrl}
        episodeTitle={row.original.episodeTitle}
      />
    ),
    disableSortBy: true,
    width: 800,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Views</Heading>} />
    ),
    id: 'views',
    Cell: ({ row }: CellProps<SocialSharePodcastEpisode>) => (
      <TableCells.NumericCell
        value={row.original.statistics.viewCount}
        isValueStale={row.original.statistics.isViewCountStale}
      />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Likes</Heading>} />
    ),
    id: 'likes',
    Cell: ({ row }: CellProps<SocialSharePodcastEpisode>) => (
      <TableCells.NumericCell value={row.original.statistics.likeCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Comments</Heading>} />
    ),
    id: 'comments',
    Cell: ({ row }: CellProps<SocialSharePodcastEpisode>) => (
      <TableCells.NumericCell value={row.original.statistics.commentCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
];

export default columns;
